import { useContext, useMemo } from 'react'

import { ConfigContext, ConfigContextProps } from 'contexts'

const useConfig = () => {
  const { config, setConfig } = useContext(ConfigContext)

  const value = useMemo(() => config, [config])

  const setValue = (data: Partial<ConfigContextProps>) => {
    setConfig((prevState: ConfigContextProps) => ({
      ...prevState,
      ...data
    }))
  }

  return { config: value, setConfig: setValue }
}

export default useConfig
